import languageService from "../utils/languageService";

const LangButtons = () => {

    return <div className='ml-auto langButtons'>
        <button className='btn btn-default' onClick={() => languageService.changeLang(2)} >
            <img src="imgs/flag_da.svg" />

        </button>
        <button className='btn btn-default' onClick={() => languageService.changeLang(1)}>
            <img src="imgs/flag_en.svg" />

        </button>
        <button className='btn btn-default' onClick={() => languageService.changeLang(0)} >
            <img src="imgs/flag_sv.svg" />

        </button>
    </div>
}

export default LangButtons;